export var isWeakable = function (value) { return (value && (typeof value === 'object')
    || typeof value === 'function'); };
